import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { fmtDate } from "./shared";

export const NewBadge = () => <span className="ml-1.5 rounded-full bg-emerald-600 px-1.5 py-0.5 text-[10px] font-bold text-white align-middle" data-testid="new-badge">Nuovo</span>;

const Group = ({ title, items, testid }) => (!items?.length ? null : (
  <div data-testid={testid}><div className="text-[11px] font-bold uppercase tracking-wider text-slate-600">{title} ({items.length})</div>
    <ul className="mt-0.5 text-sm list-disc pl-5">{items.map((x, i) => <li key={i} className="break-words">{x}</li>)}</ul></div>
));

export const useNovita = (a, con) => {
  const [n, setN] = useState(null);
  useEffect(() => { api.get(`/admin-ai/competitor/${a.id}/novita`, { params: con ? { con } : {} }).then((r) => setN(r.data)).catch(() => setN({ base: null })); }, [a.id, con]);
  return n;
};

export const NovitaPanel = ({ n, history, a, con, setCon }) => {
  const others = (history || []).filter((x) => x.id !== a.id);
  if (!others.length) return null;
  const empty = n?.base && !n.nuovi_competitor.length && !n.scomparsi.length && !n.nuovi_trend.length && !n.nuove_fonti.length;
  return (
    <div className="mb-4 rounded-xl border-2 border-emerald-600/50 bg-emerald-50 p-3" data-testid="novita-panel">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-1.5 font-bold text-[#0A1128]"><Sparkles className="h-4 w-4 text-emerald-700" />{n?.base ? `Novità dall'ultima analisi (${fmtDate(n.base.created_at)})` : "Nessuna analisi precedente da confrontare"}</div>
        <Select value={con || "auto"} onValueChange={(v) => setCon(v === "auto" ? null : v)}>
          <SelectTrigger className="h-8 w-full sm:w-[230px] rounded-lg bg-white text-xs" data-testid="novita-compare-select"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="auto">Confronta con la precedente</SelectItem>{others.map((x) => <SelectItem key={x.id} value={x.id}>Confronta con {fmtDate(x.created_at)}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      {empty && <div className="mt-2 text-sm text-slate-700">Nessuna differenza rilevante.</div>}
      {n?.base && (
        <div className="mt-2 grid gap-2 sm:grid-cols-2">
          <Group title="Nuovi competitor" items={n.nuovi_competitor} testid="novita-new-competitors" />
          <Group title="Non più trovati" items={n.scomparsi} testid="novita-gone-competitors" />
          <Group title="Nuovi trend" items={n.nuovi_trend} testid="novita-new-trends" />
          <Group title="Nuove fonti" items={n.nuove_fonti.map((f) => `[${f.n}] ${f.titolo}`)} testid="novita-new-sources" />
        </div>
      )}
    </div>
  );
};
